import OrderEdit from './OrderEdit';
import OrderIcon from '@material-ui/icons/ShoppingBasket';
import OrderList from './OrderList';

export default {
  list: OrderList,
  edit: OrderEdit,
  icon: OrderIcon,
};
